module.exports = __webpack_public_path__ + "img/5.46c06058.jpg";